import { Skeleton, Stack } from '@mui/material';

import { ContentLayout } from '../layouts';

export const LazyLayout = () => {
  return (
    <ContentLayout>
      <Stack gap={3}>
        <Skeleton variant='text' height={40} width={200} />
        <Skeleton variant='rectangular' height={260} />
      </Stack>
    </ContentLayout>
  );
};
